import { render, staticRenderFns } from "./QRPre-RegisterTransaction.vue?vue&type=template&id=24085bba&scoped=true"
import script from "./QRPre-RegisterTransaction.vue?vue&type=script&lang=js"
export * from "./QRPre-RegisterTransaction.vue?vue&type=script&lang=js"
import style0 from "./QRPre-RegisterTransaction.vue?vue&type=style&index=0&id=24085bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24085bba",
  null
  
)

export default component.exports